import React from 'react';

const Navigation = ({ currentView, onViewChange }) => {
    return (
        <nav className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 transition-colors duration-200" role="navigation" aria-label="Main navigation">
            <div className="container mx-auto px-4 max-w-7xl">
                <div className="flex space-x-4 sm:space-x-8">
                    <button
                        onClick={() => onViewChange('calendar')}
                        className={`py-3 sm:py-4 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm transition-colors touch-manipulation ${currentView === 'calendar'
                            ? 'border-primary-600 dark:border-primary-500 text-primary-600 dark:text-primary-400'
                            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                            }`}
                        aria-current={currentView === 'calendar' ? 'page' : undefined}
                    >
                        <span className="flex items-center space-x-1.5 sm:space-x-2">
                            <svg
                                className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                />
                            </svg>
                            <span className="whitespace-nowrap">Calendar View</span>
                        </span>
                    </button>

                    <button
                        onClick={() => onViewChange('list')}
                        className={`py-3 sm:py-4 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm transition-colors touch-manipulation ${currentView === 'list'
                            ? 'border-primary-600 dark:border-primary-500 text-primary-600 dark:text-primary-400'
                            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                            }`}
                        aria-current={currentView === 'list' ? 'page' : undefined}
                    >
                        <span className="flex items-center space-x-1.5 sm:space-x-2">
                            <svg
                                className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                            <span className="whitespace-nowrap">List View</span>
                        </span>
                    </button>

                    <button
                        onClick={() => onViewChange('goals')}
                        className={`py-3 sm:py-4 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm transition-colors touch-manipulation ${currentView === 'goals'
                            ? 'border-primary-600 dark:border-primary-500 text-primary-600 dark:text-primary-400'
                            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                            }`}
                        aria-current={currentView === 'goals' ? 'page' : undefined}
                    >
                        <span className="flex items-center space-x-1.5 sm:space-x-2">
                            <svg
                                className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                                />
                            </svg>
                            <span className="whitespace-nowrap">Goals</span>
                        </span>
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;